var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 16.8L4.19998 26.6C3.83331 26.9667 3.36664 27.15 2.79998 27.15C2.23331 27.15 1.76664 26.9667 1.39997 26.6C1.03331 26.2333 0.849976 25.7667 0.849976 25.2C0.849976 24.6333 1.03331 24.1667 1.39997 23.8L11.2 14L1.39997 4.20001C1.03331 3.83334 0.849976 3.36667 0.849976 2.80001C0.849976 2.23334 1.03331 1.76667 1.39997 1.40001C1.76664 1.03334 2.23331 0.850006 2.79998 0.850006C3.36664 0.850006 3.83331 1.03334 4.19998 1.40001L14 11.2L23.8 1.40001C24.1666 1.03334 24.6333 0.850006 25.2 0.850006C25.7666 0.850006 26.2333 1.03334 26.6 1.40001C26.9666 1.76667 27.15 2.23334 27.15 2.80001C27.15 3.36667 26.9666 3.83334 26.6 4.20001L16.8 14L26.6 23.8C26.9666 24.1667 27.15 24.6333 27.15 25.2C27.15 25.7667 26.9666 26.2333 26.6 26.6C26.2333 26.9667 25.7666 27.15 25.2 27.15C24.6333 27.15 24.1666 26.9667 23.8 26.6L14 16.8Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.d15619cf2b3c50ae3455c9c352fccaed.svg";
export { ForwardRef as ReactComponent };